export default "__VITE_ASSET__CXSnozjS__"